import { render, staticRenderFns } from "./AccountSetting.vue?vue&type=template&id=325f5992&scoped=true"
import script from "./AccountSetting.vue?vue&type=script&lang=js"
export * from "./AccountSetting.vue?vue&type=script&lang=js"
import style0 from "./AccountSetting.vue?vue&type=style&index=0&id=325f5992&prod&lang=scss&scoped=true"
import style1 from "./AccountSetting.vue?vue&type=style&index=1&id=325f5992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325f5992",
  null
  
)

export default component.exports